export const faceActionMeta = [
  { name: "right", description: "faceActions.turnRight", icon: "arrow_right" },
  { name: "left", description: "faceActions.turnLeft", icon: "arrow_left" },
  { name: "up", description: "faceActions.turnUp", icon: "arrow_upward" },
  { name: "down", description: "faceActions.turnDown", icon: "arrow_downward" },
  { name: "smile", description: "faceActions.smile", icon: "sentiment_satisfied_alt" },
  { name: "rightblink", description: "faceActions.rightBlink", icon: "remove_red_eye" },
  { name: "leftblink", description: "faceActions.leftBlink", icon: "remove_red_eye" },
  { name: "completed", description: "faceActions.success", icon: "remove_red_eye" },
];